import {
  SingleSelectButtonGroup,
  SingleSelectButtonGroupData,
  SingleSelectButtonGroupHandler,
} from '../SingleSelectButtonGroup';
import variants from '@services/MarppleShop/shared/components/atoms/SectionTabs/SectionTabs.module.scss';
import { font } from '@services/MarppleShop/shared/typography';

/**
 * @design
 * https://www.figma.com/design/Top00pi5q5ylSxEviOOciV/MarppleShop-Design-System?node-id=18126-9109&t=op90Sel8hO8wqmNS-4
 */
export const createCategoryButtonGroupView = <T>(
  data: SingleSelectButtonGroupData<T>,
  handlers: SingleSelectButtonGroupHandler<T> = {},
  options: {
    /**
     * @default 'lg'
     */
    size?: 'xl' | 'lg';
  } = {},
): SingleSelectButtonGroup<T> => {
  const sizeMap = {
    xl: variants.xLarge,
    lg: variants.large,
    xs: variants.xSmall,
  };

  const size = (options.size && sizeMap[options.size]) ?? sizeMap.lg;
  const typo = options.size === 'xl' ? font('18_medium') : font('14_medium');

  return new SingleSelectButtonGroup(data, {
    container_class: `${variants.tabs} ${variants.bubble} ${size}`,
    button_class: `${variants.tab} ${typo}`,
    active_class: variants.active,
    ...handlers,
  });
};
